'use client'

import Link from 'next/link'
import Image from 'next/image'
import { Phone } from 'lucide-react'
import { PHONE } from '@/const'

interface HeaderProps {
    onNavigate?: (section: string) => void
}

const navLinkClass = "text-sm font-medium text-white/80 no-underline hover:text-white transition-colors duration-200"

const navItems = [
    { href: '#about', text: 'О нас' },
    { href: '#how', text: 'Как это работает' },
    { href: '#features', text: 'Возможности' }
]

const Header = ({ onNavigate }: HeaderProps) => {
    const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, section: string) => {
        e.preventDefault()
        const element = document.querySelector(section)
        element?.scrollIntoView({ behavior: 'smooth' })
        onNavigate?.(section)
    }

    return (
        <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md bg-[linear-gradient(90.13deg,#00abe4_16.16%,#290543_89.72%)]">
            <div className="max-w-[1400px] mx-auto px-8 h-16 flex items-center justify-between">
                <div onClick={() => scroll({ top: 0, behavior: 'smooth' })} className="flex items-center gap-2 no-underline cursor-pointer">
                    <Image src="/img/logo.svg" alt="Банкрот Консалт" className="h-8 w-8" width={40} height={40} />
                    <span className="text-xl font-bold text-white">Банкрот Консалт</span>
                </div>
                <nav className="hidden md:flex items-center gap-8">
                    {navItems.map((item) => (
                        <a key={item.href} href={item.href} onClick={(e) => handleNavClick(e, item.href)} className={navLinkClass}>
                            {item.text}
                        </a>
                    ))}
                    
                    <Link
                        href='/recomendation'
                        className={navLinkClass}
                    >
                        Программа рекомендаций
                    </Link>
                </nav>
                <div className="flex items-center gap-3">
                    <a href={`tel:${Object.keys(PHONE)[0]}`} className="hidden lg:flex items-center gap-1.5 text-sm font-medium text-white no-underline">
                        <Phone className="h-4 w-4 fill-white" width={16} height={16} />
                        {PHONE['+74992888087']}
                    </a>
                    <Link href="/auth/signin">
                        <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:text-accent-foreground h-9 rounded-md px-3 text-white hover:bg-white/10">
                            Войти
                        </button>
                    </Link>
                    <Link href="/auth/signup">
                        <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 h-9 rounded-md px-3 bg-white text-primary hover:bg-white/90">
                            Подать заявку
                        </button>
                    </Link>
                </div>
            </div>
        </header>
    )
}

export default Header
